import { Button, useMediaQuery, useTheme } from '@mui/material';
import * as React from 'react';
import * as PXBColors from '@brightlayer-ui/colors';
import * as MuiIcons from '@mui/icons-material';
import { ArrowDropDown } from '@material-ui/icons';
import { useLanguageLocale } from '../../hooks/language-locale-hooks';

export interface Props {
    disabled?: boolean;
    onClick: () => void;
    testId: string;
}

const DownloadButton: React.FunctionComponent<Props> = (props) => {

    const { disabled = false, onClick, testId } = props;
    const { t } = useLanguageLocale();
    const theme = useTheme();
    const md = useMediaQuery(theme.breakpoints.up('md'));

    return (
        <Button
            disabled={disabled}
            id={testId}
            data-testid={testId}
            style={{
                opacity: 0.5,
                flexDirection: 'row',
                backgroundColor: PXBColors.blue[700],
                color: PXBColors.white[50],
                marginRight: 10,
                textTransform: 'none'
            }}
            onClick={onClick}>
            <MuiIcons.GetApp style={{ padding: 3 }} />
            {md ? t('ASSETS_DETAILS.DOWNLOAD_AS') : ''}
            <ArrowDropDown style={{ padding: 3 }} />
        </Button>
    );
};

export default DownloadButton;
